module.exports = __webpack_public_path__ + "img/oth16.d5b98233.png";